module.exports = __webpack_public_path__ + "static/media/avast-vince-showman.80d86f45.jpg";